<template>
  <div  >
    <Header></Header>
    <Title :title="(($route.query.copy?'复制':$route.query.id?'编辑':'发布')+ '考试')"></Title>
    <div class="contain_main main">
      <div class="title">基本设置</div>
      <div class="item">
        <span>考试名称</span>
        <Input v-model="data.examtitle" placeholder="请填写考试名称" style="width:2rem"/>
      </div>
      <div class="item">
        <span>考试描述</span>
        <Input v-model="data.examdescrip" style="width:5rem"/>
      </div>
      <div class="item">
        <span>选择试卷</span>
        <Select
          v-model="data.exampid"
          filterable
          @on-change="examchange"
          placeholder="请选择"
          style="width:200px"
        >
          <!-- <Option disabled :alue="''">请选择</Option> -->
          <Option v-for="item in list" :value="item.epid" :key="item.epid">{{ item.eptitle }}</Option>
        </Select>
        共{{examtotal}}题，总分{{examscoretotal}}分
        <!-- <div class="button" @click="$router.push('/manage/publiclist')" style="float:right">创建试卷</div> -->
      </div>
      <div class="item">
        <span>及格分数</span>
        <InputNumber :max="examscoretotal" :min="1" v-model="data.examscore"></InputNumber>分
      </div>
      <div class="item">
        <span>考试时间</span>
        <DatePicker
          v-if="!data.examunlimt"
          type="datetimerange"
          v-model="time"
          placeholder="请选择考试时间段"
          style="width: 300px"
        ></DatePicker>
        <!-- <Checkbox v-model="data.examunlimt">无限制</Checkbox> -->
      </div>
      <div class="item">
        <span>应试组织</span>
        <Button v-if="!data.examislogin" @click="model=true" type="primary" size="small">选择部门/组织</Button>
        <Checkbox v-model="data.examislogin">免登陆</Checkbox>
      </div>
      <div class="item">
        <span>考试时长</span>
        <InputNumber :min="1" v-model="data.examtime"></InputNumber>分
      </div>
      <div v-if="!data.examislogin">
        <div class="title">考试设置</div>
        <div class="item">
          <span>可作答次数</span>
          <span v-if="!noLimit">
            <InputNumber :max="100" :min="1" v-model="data.examnum"></InputNumber>次
          </span>
          <Checkbox v-model="noLimit">无限制</Checkbox>
        </div>
      </div>
      <div class="title">提交考试</div>
      <div class="item">
        <Checkbox :disabled="examItem==1" v-model="data.examdecide">显示成绩单</Checkbox>
        <!-- <span style="color:#8f9cad">若试卷有主观题，将不能显示完整的成绩单</span> -->
      </div>
      <div class="item" v-if="!data.examdecide">
        <span>提示文案</span>
        <Input v-model="data.examcue" placeholder="请输入提交试卷后得提示语" style="width:5rem"/>
      </div>
      <div class="bottom">
        <Button style="margin-right:100px" @click="$router.go(-1)">取消</Button>
        <div class="button" @click="add">确定{{$route.query.copy?"复制":$route.query.id?"编辑":"发布"}}</div>
      </div>
    </div>
    <div style="height:200px"></div>
    <Modal v-model="model" title="请选择部门或组织">
      <Tree
        style="max-height:400px;overflow-y:auto"
        :data="orglist"
        @on-check-change="checkdata"
        show-checkbox
        multiple
        v-model="valued"
      ></Tree>
      <div slot="footer">
        <Button type="error" size="large" @click="model=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Header from "@/components/header";
import Title from "@/components/title";
import {
  ExamPaper_addExam,
  ExamPaper_indexp,
  Organize_index,
  Exam_getExam,
  Exam_updateExam
} from "../../assets/js/api.js";
export default {
  name: "testlist",
  data() {
    return {
      time: null,
      model: false,
      examtotal: 0,
      examscoretotal: 0,
      list: [],
      orglist: [],
      examItem:null,
      data: {
        examtitle: null, //	string	true	普通参数		标题
        examdescrip: null, //		string	true	普通参数		描述
        exampid: null, //		number	true	普通参数		试卷id
        examsid: null, //		number	true	普通参数		部门id
        examscore: null, //		number	true	普通参数		及格分数
        examtime: 60, //		number	true	普通参数		考试时长
        examunlimt: null, //		number	true	普通参数		考试时间：0有限制1无限制
        examislogin: null, //		number	true	普通参数		0免登陆1需登陆
        examstartime: null, //		number	true	普通参数		考试开始时间
        examendtime: null, //		number	true	普通参数		考试过期时间
        examnum: 1, //		number	true	普通参数		可作答次数
        examdecide: null, //		number	true	普通参数		0需阅卷1无需阅卷
        examcue: "你的答卷已经提交，感谢您的参与！考试截止后将公布答案！" //		string	true	普通参数		交卷后提示语
      },
      noLimit: false,
      valued: []
    };
  },
  mounted() {
    this.getOrganize();
    this.$nextTick(() => {
      document
        .querySelector(".ivu-date-picker-rel .ivu-input-with-suffix")
        .setAttribute("disabled", "disabled");
    });
  },
  components: {
    Header,
    Title
  },
  methods: {
    messageinit() {
      Exam_getExam({ examid: this.$route.query.id }).then(res => {
        if (res.data.code == 200) {
          for (var item in this.data) {
            this.data[item] = res.data.data[item];
          }
          function formated(value) {
            if (value == 0) {
              return false;
            } else {
              return true;
            }
          }
          this.examchange(this.data.exampid);
          this.data.examdecide = formated(this.data.examdecide);
          this.data.examislogin = this.data.examislogin == 1 ? false : true;
          this.data.examunlimt = formated(this.data.examunlimt);
          if (this.data.examnum == -1) {
            this.noLimit = true;
          }
          this.time = [
            new Date(Number(this.data.examstartime) * 1000),
            new Date(Number(this.data.examendtime) * 1000)
          ];
          // 针对编辑组织得选取初始化
          // this.orglist  递归遍历重构方法
          function rangedata(data) {
            if (data.length > 0) {
              data = data.map(item => {
                if (
                  res.data.data.examsid.split(",").indexOf(item.orgid + "") !=
                  -1
                ) {
                  item.selected = true;
                  item.checked = true;
                  // t.selected =false
                }
                if (item.children) {
                  item.children = rangedata(item.children);
                }
                return item;
              });
              return data;
            } else {
              return;
            }
          }
          // 重构 this.orglist
          this.orglist = rangedata(this.orglist);
        }
      });
    },
    checkdata(data) {
      this.data.examsid = data
        .map(item => {
          return item.orgid;
        })
        .join(",");
    },
    add() {
      if (!this.data.exampid) {
        this.$Notice.error({ title: "错误提示", desc: "考试试卷不能为空" });
        return;
      }
      if (!this.data.examtitle) {
        this.$Notice.error({ title: "错误提示", desc: "考试名称不能为空！" });
        return;
      }
      if (this.data.examtitle.length > 100) {
        this.$Notice.error({
          title: "错误提示",
          desc: "考试名称不能超过100字！"
        });
        return;
      }
      if (this.data.examdescrip && this.data.examdescrip.length > 2000) {
        this.$Notice.error({
          title: "错误提示",
          desc: "考试名称不能超过2000字！"
        });
        return;
      }
      if (!this.data.examcue) {
        this.$Notice.error({
          title: "错误提示",
          desc: "交卷后提示语不能为空！"
        });
        return;
      }
      if (this.data.examcue && this.data.examcue.length > 200) {
        this.$Notice.error({
          title: "错误提示",
          desc: "交卷后提示语不能超过200字！"
        });
        return;
      }
      if (!this.data.examislogin && !this.data.examsid) {
        this.errorPlus("非免登陆状态下，组织机构不能为空！");
        return;
      }
      if (!this.time[0]) {
        this.errorPlus("考试时间不能为空！");
        return;
      }
      if (this.data.examislogin) {
        this.data.examsid = null;
      }
      if (this.data.examunlimt) {
        this.data.examstartime = null;
        this.data.examendtime = null;
      } else if (this.time && !this.data.examunlimt) {
        var time1 = new Date(this.time[0]);
        var time2 = new Date(this.time[1]);
        this.data.examstartime = Math.round(time1.getTime() / 1000);
        this.data.examendtime = Math.round(time2.getTime() / 1000);
      }
      var data = JSON.parse(JSON.stringify(this.data));
      if (this.noLimit||this.data.examislogin) {
        data.examnum = -1;
      }
      data.examislogin = this.data.examislogin ? 0 : 1;
      data.examdecide = this.data.examdecide ? 1 : 0;
      data.examunlimt = this.data.examunlimt ? 1 : 0;
      if (this.$route.query.id && !this.$route.query.copy) {
        data.examid = this.$route.query.id;
        Exam_updateExam(data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "编辑成功！" });
            this.$router.push("/managelist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      } else {
        ExamPaper_addExam(data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "发布成功！" });
            this.$router.push("/managelist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      }
    },
    getlist() {
      ExamPaper_indexp({
        eptitle: "", //	string	true	普通参数		标题
        page: 1, //	string	true	普通参数		页码
        size: 100000000000 //	string	true	普通参数		数量
      }).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
        }
        if (this.$route.query.id) {
          this.messageinit();
        }
      });
    },
    examchange(data) {
      var t = this.list.filter(item => {
        return item.epid == data;
      })[0];
      this.examtotal = t.epcount;
      this.examscoretotal = t.epscore;
      this.examItem = t.epitem
      console.log(this.examItem)
      this.data.examdecide = t.epitem == 1 ? false : true;
    },
    getOrganize() {
      Organize_index().then(res => {
        if (res.data.code == 200) {
          this.orglist = [];
          // 递归遍历 res.data.data
          function rangedata(data) {
            if (data.length > 0) {
              data = data.map(item => {
                var t = {};
                t.expand = false;
                t.orgid = item.orgid;
                t.title = item.orgname;
                t.checked = false;
                t.selected = false;
                if (item.child) {
                  t.children = rangedata(item.child);
                }
                return t;
              });
              return data;
            } else {
              return;
            }
          }
          this.orglist = rangedata(res.data.data);
        }
        this.getlist();
      });
    }
  }
};
</script>
<style lang="css" scoped>
.main {
  text-align: left;
  padding-left: 0.5rem;
  box-sizing: border-box;
  background: #f9fafc;
}
.title {
  font-size: 0.2rem;
  line-height: 0.8rem;
  color: #464646;
  font-weight: 500;
}
.item {
  margin-bottom: 0.15rem;
  font-size: 0.14rem;
}
.item span {
  margin-right: 0.2rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  text-align: center;
  display: inline-block;
}
.bottom {
  display: flex;
  justify-content: space-around;
  width: 300px;
  margin: 0 auto;
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/publicpaper.vue